class CreateMultiPackageReq {
  constructor() {
    this.packageSessions = [];
    this.patientId = undefined;
    this.packageName = undefined;
    this.startdate = undefined;
  }
}
export default CreateMultiPackageReq;
